import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {  PopoverController } from '@ionic/angular';
@Component({
  selector: 'app-double-input',
  templateUrl: './double-input.component.html',
  styleUrls: ['./double-input.component.scss'],
})
export class DoubleInputComponent implements OnInit {
  @Input() onboardingFlowStep: any; // Consider providing a more specific type
  @Output() onChangeValues: EventEmitter<{ firstValue: string, secondValue: string }> = new EventEmitter<{ firstValue: string, secondValue: string }>();
/*
  @ViewChild('tooltip', { static: false }) tooltipRef!: ElementRef;
  @ViewChild('triggerInput', { static: false }) triggerInputRef!: ElementRef;*/

  formGroup: FormGroup;

  searchTerm: string = '';
/*
  tooltipVisible: boolean = false;
  tooltipPosition = { top: '0px', left: '0px' };*/

  selectedPhone: any;

  constructor(
    private popoverCtrl: PopoverController
  ) {
    this.formGroup = new FormGroup({
      firstInput: new FormControl('', []),
      secondInput: new FormControl('', []),
      /*phoneExtension: new FormControl('', [Validators.required])*/
    });
  }

  ngOnInit() {
    this.setupValidation();
    this.formGroup.valueChanges.subscribe(({ firstInput, secondInput }) => {
      if (this.formGroup.valid) {
        
        firstInput = firstInput.trim();
        secondInput = secondInput.trim();
        /*phoneExtension = phoneExtension.trim();*/

        // check if has the plus sign the extension and if it doesnt have add it
        /*if (phoneExtension && phoneExtension[0] !== '+') {
          phoneExtension = '+' + phoneExtension;
        }*/

        /*secondInput = phoneExtension + ' ' + secondInput;*/

        this.onChangeValues.emit({ firstValue: firstInput, secondValue: secondInput});
      } else {
        // Consider handling invalid state, e.g., by not emitting or emitting a specific value
      }
    });
  }

  setSearchTerm(event: any) {
    this.searchTerm = event.target.value;
  }

  onSelectPhone(phone: any) {
    /*this.tooltipVisible = false;*/
    this.selectedPhone = phone;
    /*this.formGroup.controls['phoneExtension'].setValue(phone?.dial_code);*/
  }

  /*onExtensionSelectorClick(e: any) {
    e.stopPropagation(); // Prevent the click from immediately triggering the @HostListener
    this.tooltipVisible = true;

    const rect = (e.target as HTMLElement).getBoundingClientRect();
    this.tooltipPosition.top = rect.bottom + window.scrollY + 'px';
    this.tooltipPosition.left = rect.left + window.scrollX + 'px';
  }

  showTooltip(event: MouseEvent) {
    this.tooltipVisible = true;
    const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.tooltipPosition.top = rect.bottom + window.scrollY + 'px';
    this.tooltipPosition.left = rect.left + window.scrollX + 'px';
  }*/


  setupValidation() {
    // Assuming the validation rules are passed as an array, where each item corresponds to each input's rules
    const validationRules = this.onboardingFlowStep.validation;
    if (!validationRules || validationRules.length === 0) return;
  
    // Apply validation rules for each input based on its index
    validationRules.forEach((rules: any, index: any) => {
      const validators = [];
      if (rules.required) {
        validators.push(Validators.required);
      }
      if (rules.email) {
        validators.push(Validators.email);
      }
      if (rules.number) {
        validators.push(Validators.pattern('^\+?[0-9]*$'));
      }
  
      const controlName = index === 0 ? 'firstInput' : 'secondInput';
      this.formGroup.controls[controlName].setValidators(validators);
    });
  
    this.formGroup.updateValueAndValidity();
  }

  getErrors(controlName: string): string[] {
    const control = this.formGroup.get(controlName);
    if (!control || !control.errors) return [];
  
    const errorMessages = [];
    if (control.errors['required']) errorMessages.push('Campo obligatorio');
    if (control.errors['email']) errorMessages.push('Email no válido');
    if (control.errors['pattern']) errorMessages.push('No es un número'); // For number validation or other pattern-based validations
  
    return errorMessages;
  }


  // PHONE EXTENSION MODAL CONTROLLER
  

 /* @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.tooltipVisible && !this.tooltipRef.nativeElement.contains(event.target) && !this.triggerInputRef.nativeElement.contains(event.target)) {
      this.tooltipVisible = false;
    }
  }*/
}